<template>
    <div id="plan-feature">
        <div class="feature">
            <div class="feature-title">Webphone Özellikleri</div>
            <div class="feature-delete" @click="$emit('close')"><span class="material-icons">close</span></div>
        </div>
        <div class="feature-form">
            <!-- Kanal Sayısı -->
            <div class="feature-item">
                <div class="feature-label">Kanal Sayısı</div>
                <div class="feature-input">
                    <a-input class="plan-input" :min="0" type="number" v-model="featureForm.webphoneChannelCount" />
                </div>
            </div>

            <div class="feature-item">
                <div class="feature-checkbox">
                    <a-checkbox v-model="featureForm.integratedWebPhone">Entegre Web Telefonu</a-checkbox>
                </div>
            </div>

            <div class="feature-item">
                <div class="feature-checkbox">
                    <a-checkbox v-model="featureForm.clickToCall">Click to Call Özelliği</a-checkbox>
                </div>
            </div>

            <div class="feature-item">
                <div class="feature-checkbox">
                    <a-checkbox v-model="featureForm.callHistory">Web telefonu için Arama Geçmişi</a-checkbox>
                </div>
            </div>

            <div class="feature-item">
                <div class="feature-checkbox">
                    <a-checkbox v-model="featureForm.generalCallRecords">Genel Arama Kayıtları</a-checkbox>
                </div>
            </div>

            <div class="feature-item">
                <div class="feature-checkbox">
                    <a-checkbox v-model="featureForm.userExtensionMapping">Kullanıcı Dahili Eşleştirme</a-checkbox>
                </div>
            </div>

            <div class="feature-item">
                <div class="feature-checkbox">
                    <a-checkbox v-model="featureForm.webphoneAutomations">Webphone Otomasyonları</a-checkbox>
                </div>
            </div>

            <div class="feature-item">
                <div class="feature-checkbox">
                    <a-checkbox v-model="featureForm.extensionListing">Dahili Listeleme</a-checkbox>
                </div>
            </div>

            <div class="feature-item">
                <div class="feature-checkbox">
                    <a-checkbox v-model="featureForm.internalCalling">Dahili Arama</a-checkbox>
                </div>
            </div>

            <div class="feature-item">
                <div class="feature-checkbox">
                    <a-checkbox v-model="featureForm.callRouting">Arama Yönlendirme (Kırmızı Santral)</a-checkbox>
                </div>
            </div>

            <div class="feature-item">
                <div class="feature-checkbox">
                    <a-checkbox v-model="featureForm.coldCallStart">Soğuk Arama Başlat (Kırmızı Santral)</a-checkbox>
                </div>
            </div>

            <div class="feature-item">
                <div class="feature-checkbox">
                    <a-checkbox v-model="featureForm.automationColdCall">Otomasyon ile Soğuk Arama Başlatma (Kırmızı Santral)</a-checkbox>
                </div>
            </div>

            <div class="feature-item">
                <div class="feature-checkbox">
                    <a-checkbox v-model="featureForm.ivr">IVR (Kırmızı Santral)</a-checkbox>
                </div>
            </div>

            <div class="feature-item">
                <div class="feature-checkbox">
                    <a-checkbox v-model="featureForm.voiceAnnouncement">Ses Kaydı Anons Dinletme (Kırmızı Santral)</a-checkbox>
                </div>
            </div>

            <div class="feature-item">
                <div class="feature-checkbox">
                    <a-checkbox v-model="featureForm.satisfactionSurveyCall">Memnuniyet Anketi Araması (Kırmızı Santral)</a-checkbox>
                </div>
            </div>

            <div class="feature-item">
                <div class="feature-checkbox">
                    <a-checkbox v-model="featureForm.customizableCloudPbx">Özelleştirilebilir Bulut Santral (Kırmızı Santral)</a-checkbox>
                </div>
            </div>

            <div class="feature-item">
                <div class="feature-checkbox">
                    <a-checkbox v-model="featureForm.liveQueueMonitoring">Canlı Kuyruk İzleme (Kırmızı Santral)</a-checkbox>
                </div>
            </div>

            <div class="feature-item">
                <div class="feature-checkbox">
                    <a-checkbox v-model="featureForm.aiVoiceAgentIntegration">Yapay Zeka Voice Agent ile Entegrasyon (Kırmızı Santral)</a-checkbox>
                </div>
            </div>

            <div class="feature-item">
                <div class="feature-checkbox">
                    <a-checkbox v-model="featureForm.contactCallHistory">Kişi Kartlarında Arama Geçmişi Gösterme</a-checkbox>
                </div>
            </div>

            <div class="feature-item">
                <div class="feature-checkbox">
                    <a-checkbox v-model="featureForm.callProfileDisplay">Çağrı Anında Profil Gösterme</a-checkbox>
                </div>
            </div>

            <div class="feature-item">
                <div class="feature-checkbox">
                    <a-checkbox v-model="featureForm.multipleWebPhone">Çoklu Web Telefonu (Telnyx)</a-checkbox>
                </div>
            </div>

            <div class="feature-item">
                <div class="feature-checkbox">
                    <a-checkbox v-model="featureForm.voiceRecordingStorage">Ses Kaydı Saklama</a-checkbox>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { FeatureItems, Features } from "./index";

export default {
    name: "Webphone",
    props: {
        value: {
            type: Object,
            default: {},
        },
    },
    data: () => ({
        form: {},
        featureForm: {
            webphoneChannelCount: 0,
            // Temel Özellikler
            integratedWebPhone: false,
            clickToCall: false,
            callHistory: false,
            generalCallRecords: false,
            userExtensionMapping: false,
            webphoneAutomations: false,
            extensionListing: false,
            internalCalling: false,
            contactCallHistory: false,
            callProfileDisplay: false,
            voiceRecordingStorage: false,
            // Kırmızı Santral Özel Özellikleri
            callRouting: false,
            coldCallStart: false,
            automationColdCall: false,
            ivr: false,
            voiceAnnouncement: false,
            satisfactionSurveyCall: false,
            customizableCloudPbx: false,
            liveQueueMonitoring: false,
            aiVoiceAgentIntegration: false,
            // Telnyx Özel Özellikleri
            multipleWebPhone: false,
        },
    }),
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.form = this.$_.cloneDeep(this.value);
            const feature = this.form.features.find((x) => x.type === FeatureItems.WEB_PHONE);
            
            if (feature) {
                this.featureForm = {
                    webphoneChannelCount: feature[Features.WEB_PHONE.CHANNEL_COUNT] || 0,
                    // Temel özellikler
                    integratedWebPhone: !!feature[Features.WEB_PHONE.INTEGRATED_WEB_PHONE],
                    clickToCall: !!feature[Features.WEB_PHONE.CLICK_TO_CALL],
                    callHistory: !!feature[Features.WEB_PHONE.CALL_HISTORY],
                    generalCallRecords: !!feature[Features.WEB_PHONE.GENERAL_CALL_RECORDS],
                    userExtensionMapping: !!feature[Features.WEB_PHONE.USER_EXTENSION_MAPPING],
                    webphoneAutomations: !!feature[Features.WEB_PHONE.WEBPHONE_AUTOMATIONS],
                    extensionListing: !!feature[Features.WEB_PHONE.EXTENSION_LISTING],
                    internalCalling: !!feature[Features.WEB_PHONE.INTERNAL_CALLING],
                    contactCallHistory: !!feature[Features.WEB_PHONE.CONTACT_CALL_HISTORY],
                    callProfileDisplay: !!feature[Features.WEB_PHONE.CALL_PROFILE_DISPLAY],
                    voiceRecordingStorage: !!feature[Features.WEB_PHONE.VOICE_RECORDING_STORAGE],
                    // Kırmızı Santral özel özellikleri
                    callRouting: !!feature[Features.WEB_PHONE.CALL_ROUTING],
                    coldCallStart: !!feature[Features.WEB_PHONE.COLD_CALL_START],
                    automationColdCall: !!feature[Features.WEB_PHONE.AUTOMATION_COLD_CALL],
                    ivr: !!feature[Features.WEB_PHONE.IVR],
                    voiceAnnouncement: !!feature[Features.WEB_PHONE.VOICE_ANNOUNCEMENT],
                    satisfactionSurveyCall: !!feature[Features.WEB_PHONE.SATISFACTION_SURVEY_CALL],
                    customizableCloudPbx: !!feature[Features.WEB_PHONE.CUSTOMIZABLE_CLOUD_PBX],
                    liveQueueMonitoring: !!feature[Features.WEB_PHONE.LIVE_QUEUE_MONITORING],
                    aiVoiceAgentIntegration: !!feature[Features.WEB_PHONE.AI_VOICE_AGENT_INTEGRATION],
                    // Telnyx özel özellikleri
                    multipleWebPhone: !!feature[Features.WEB_PHONE.MULTIPLE_WEB_PHONE],
                };
            }
        },
    },
    watch: {
        value: {
            deep: true,
            handler() {
                this.init();
            },
        },
        form: {
            handler(newVal, oldVal) {
                if (!this.$_.isEqual(this.value, oldVal)) {
                    this.$emit("input", newVal);
                }
            },
            deep: true,
        },
        featureForm: {
            handler(v) {
                const response = { type: "webphone", ...this.featureForm };
                
                // Kanal sayısı
                response[Features.WEB_PHONE.CHANNEL_COUNT] = +v.webphoneChannelCount || 0;
                
                // Temel özellikler
                response[Features.WEB_PHONE.INTEGRATED_WEB_PHONE] = !!v.integratedWebPhone;
                response[Features.WEB_PHONE.CLICK_TO_CALL] = !!v.clickToCall;
                response[Features.WEB_PHONE.CALL_HISTORY] = !!v.callHistory;
                response[Features.WEB_PHONE.GENERAL_CALL_RECORDS] = !!v.generalCallRecords;
                response[Features.WEB_PHONE.USER_EXTENSION_MAPPING] = !!v.userExtensionMapping;
                response[Features.WEB_PHONE.WEBPHONE_AUTOMATIONS] = !!v.webphoneAutomations;
                response[Features.WEB_PHONE.EXTENSION_LISTING] = !!v.extensionListing;
                response[Features.WEB_PHONE.INTERNAL_CALLING] = !!v.internalCalling;
                response[Features.WEB_PHONE.CONTACT_CALL_HISTORY] = !!v.contactCallHistory;
                response[Features.WEB_PHONE.CALL_PROFILE_DISPLAY] = !!v.callProfileDisplay;
                response[Features.WEB_PHONE.VOICE_RECORDING_STORAGE] = !!v.voiceRecordingStorage;
                
                // Kırmızı Santral özel özellikleri
                response[Features.WEB_PHONE.CALL_ROUTING] = !!v.callRouting;
                response[Features.WEB_PHONE.COLD_CALL_START] = !!v.coldCallStart;
                response[Features.WEB_PHONE.AUTOMATION_COLD_CALL] = !!v.automationColdCall;
                response[Features.WEB_PHONE.IVR] = !!v.ivr;
                response[Features.WEB_PHONE.VOICE_ANNOUNCEMENT] = !!v.voiceAnnouncement;
                response[Features.WEB_PHONE.SATISFACTION_SURVEY_CALL] = !!v.satisfactionSurveyCall;
                response[Features.WEB_PHONE.CUSTOMIZABLE_CLOUD_PBX] = !!v.customizableCloudPbx;
                response[Features.WEB_PHONE.LIVE_QUEUE_MONITORING] = !!v.liveQueueMonitoring;
                response[Features.WEB_PHONE.AI_VOICE_AGENT_INTEGRATION] = !!v.aiVoiceAgentIntegration;
                
                // Telnyx özel özellikleri
                response[Features.WEB_PHONE.MULTIPLE_WEB_PHONE] = !!v.multipleWebPhone;
                
                const feature = this.form.features.findIndex((x) => x.type === FeatureItems.WEB_PHONE);
                if (feature < 0) {
                    this.form.features = [...this.form.features, response];
                } else {
                    this.form.features.splice(feature, 1, response);
                }
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss" scoped>
$bg-color: #ec4b1d;

#plan-feature {
    margin-top: 20px;

    .feature {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .feature-title {
            font-weight: bold;
            font-size: 16px;
        }

        .feature-delete {
            background-color: $bg-color;
            padding: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 2px;
            cursor: pointer;

            span {
                font-size: 14px;
                color: white;
            }
        }
    }

    .feature-form {
        .feature-item {
            margin-bottom: 15px;
            
            .feature-label {
                margin-bottom: 8px;
                font-weight: 500;
                color: #333;
            }

            .feature-input {
                .plan-input {
                    width: 100%;
                }
            }

            .feature-checkbox {
                padding: 8px 0;
                
                :deep(.ant-checkbox-wrapper) {
                    font-size: 14px;
                    color: #555;
                }
            }
        }
    }
}
</style>
